<script lang="ts">
  import CustomTabs from 'scripts/global_components/CustomTabs.svelte';
  import { navigate } from 'svelte-routing';
  import {
    purchasesPageCondition,
    slipTableConfig,
    slipTypeChoice,
    slipTypeChoiceInverse,
  } from './config/store';
  import Spinner from 'scripts/global_components/child_components/Spinner.svelte';
  import SlipList from './SlipList.svelte';
  import TabPanel from 'scripts/global_components/child_components/TabPanel.svelte';
  import AdvancedSearchForm from 'scripts/global_components/child_components/AdvancedSearchForm.svelte';
  import type {
    ChoiceDisplayMap,
    FormConfig,
    SearchParamObj,
    SimpleFormConfig,
  } from 'scripts/utils/types';
  import { defaultFieldOptions } from 'scripts/utils/utils';
  import {
    makeConfigFromOptions,
    searchParamToQueryParams,
  } from 'scripts/utils/form_utils';
  import { fetchGetRequest } from 'scripts/utils/fetcher';
  import { routeStockerApp } from 'scripts/router';
  import { rebuildSearchParamObj } from 'scripts/utils/commonStates';
  import SlipItemListForPurchase from './SlipItemListForPurchase.svelte';
  import { dateToStr } from 'scripts/utils/date_utils';

  const tabs = Object.values($slipTypeChoice);
  let searchParamObj: SearchParamObj;
  let searchFields;
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  const listTypeTabs = ['伝票', '内訳'];
  let spinnerDisplay = false;
  let slipList = [];
  let choiceDisplayMap: ChoiceDisplayMap = {};

  let slipFormConfig: FormConfig = {};
  let simpleFormConfig: SimpleFormConfig = {
    Row_1: {
      type: {
        name: '種類',
        inputClass: 'col-12 col-md-4',
      },
      number: {
        name: '伝票番号',
        inputClass: 'col-12 col-md-4',
      },
      date_created: {
        name: '作成日',
        inputClass: 'col-12 col-md-4',
        options: { ...defaultFieldOptions, label: '作成日' },
      },
    },
    Row_2: {
      order: {
        name: '売上',
        inputClass: 'col-12 col-md-4',
      },
    },
    Row_3: {
      slipitem_set: {
        name: '内訳',
        inputClass: 'col-12',
        options: { label: '伝票内訳' },
      },
    },
  };

  const getDataSets = async (type: string) => {
    const configRes = await makeConfigFromOptions(
      routeStockerApp.slipApi(),
      simpleFormConfig,
      $slipTableConfig,
    );
    slipFormConfig = configRes.formConfig;
    $slipTableConfig = configRes.tableConfig;
    choiceDisplayMap = configRes.choiceDisplayMap;
    const rebuilt = rebuildSearchParamObj(
      configRes.searchParamObj,
      $purchasesPageCondition.searchParamObj,
      searchFields,
    );
    searchParamObj = rebuilt.searchParamObj;
    searchFields = rebuilt.searchFields;
    getSlips();
  };

  const getSlips = async () => {
    spinnerDisplay = true;
    // 日付が入力されなければ検索開始日時を2年に絞り込む
    if (
      !$purchasesPageCondition.searchParamObj.date_created ||
      !Array.isArray(
        $purchasesPageCondition.searchParamObj.date_created.value,
      ) ||
      $purchasesPageCondition.searchParamObj.date_created.value.length == 0
    ) {
      const startDate = new Date(date);
      startDate.setFullYear(date.getFullYear() - 1);
      $purchasesPageCondition.searchParamObj.date_created = {
        type: 'range',
        value: [`${dateToStr(startDate).iso8601Format}`, ''],
      };
    }
    const slip_type = $slipTypeChoiceInverse[$purchasesPageCondition.activeTab];
    let params = {
      ...searchParamToQueryParams(
        $purchasesPageCondition.searchParamObj,
        searchFields,
      ),
      slip_type: slip_type,
    };
    //console.log(params);
    const res = await fetchGetRequest({
      endpoint: routeStockerApp.slipApi(),
      errorMessage: '伝票の取得に失敗しました。',
      params: params,
    });
    if (res.success) slipList = res.data;
    //console.log(slipList);

    spinnerDisplay = false;
  };

  $: getDataSets($purchasesPageCondition.activeTab);
  //$: console.log($purchasesPageCondition);

  const onAdavancedSearch = (event) => {
    $purchasesPageCondition.searchParamObj = event.detail;
    getSlips();
  };
</script>

<svelte:head>
  <!-- Material Typography -->
  <link
    rel="stylesheet"
    href="https://unpkg.com/@material/typography@13.0.0/dist/mdc.typography.css"
  />
  <link
    href="https://fonts.googleapis.com/icon?family=Material+Icons"
    rel="stylesheet"
  />
</svelte:head>

<CustomTabs {tabs} bind:active={$purchasesPageCondition.activeTab}>
  <CustomTabs
    tabs={listTypeTabs}
    bind:active={$purchasesPageCondition.listType}
  >
    <div class="mt-2 px-2">
      <AdvancedSearchForm
        bind:searchParamObj
        bind:searchFields
        formConfig={slipFormConfig}
        hiddenFields={['order', 'type', 'slipitem_set']}
        on:searchClick={onAdavancedSearch}
      />
    </div>
    {#each Object.entries($slipTypeChoice) as choice}
      <TabPanel
        name={choice[1]}
        bind:active={$purchasesPageCondition.activeTab}
      >
        <TabPanel name="伝票" bind:active={$purchasesPageCondition.listType}>
          <SlipList {slipList} {choiceDisplayMap}></SlipList>
        </TabPanel>
        <TabPanel name="内訳" bind:active={$purchasesPageCondition.listType}>
          <SlipItemListForPurchase {slipList} {choiceDisplayMap}
          ></SlipItemListForPurchase>
        </TabPanel>
      </TabPanel>
    {/each}
  </CustomTabs>
</CustomTabs>
<div class="row my-3">
  <div class="col-12 d-flex justify-content-center">
    <button class="btn btn-primary" on:click={(e) => navigate('slip/')}>
      新規伝票作成
    </button>
  </div>
</div>
<Spinner bind:display={spinnerDisplay} />
